"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sizes = void 0;
var react_jss_1 = require("react-jss");
var theme_1 = require("../../../mantine-theme/src");
exports.sizes = {
    xs: 16,
    sm: 20,
    md: 26,
    lg: 32,
    xl: 40,
};
exports.default = react_jss_1.createUseStyles({
    themeIcon: function (_a) {
        var theme = _a.theme, color = _a.color, size = _a.size, radius = _a.radius, variant = _a.variant;
        var iconSize = theme_1.getSizeValue({ size: size, sizes: exports.sizes });
        return {
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxSizing: 'border-box',
            backgroundColor: theme_1.getThemeColor({
                theme: theme,
                color: color,
                shade: variant === 'filled' ? (theme.colorScheme === 'dark' ? 4 : 6) : 1,
            }),
            color: variant === 'filled'
                ? theme.colorScheme === 'dark'
                    ? theme.colors.dark[9]
                    : theme.white
                : theme_1.getThemeColor({ theme: theme, color: color, shade: 9 }),
            width: iconSize,
            height: iconSize,
            borderRadius: theme_1.getSizeValue({ size: radius, sizes: theme.radius }),
        };
    },
}, { link: true });
